import { get } from "@readai/common/api";
import { SessionShareRecommendation } from "@readai/common/types/sharingRecommendationsTypes";

import { withQueryParamsUrl } from "../utils";

// TODO (ENG-13915): Finalize schema for sharing recommendations and wire up to report header
export const listSessionSharingRecommendations = async (
  sessionId: string,
  limit?: number,
): Promise<SessionShareRecommendation[]> => {
  const url = withQueryParamsUrl(
    `/sharing-recommendations/sessions/${sessionId}`,
    limit && limit > 0 ? { limit } : undefined,
  );
  return get(url, {
    withCreds: true,
  });
};
